import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lines", "template"]

  connect() {
    if (this.linesTarget.children.length === 0) {
      this.addLine()
    }
    this.applyRemainderStyle()
    this.renumberLines()
  }

  renumberLines() {
    const lines = Array.from(this.linesTarget.children)
    lines.forEach((lineElement, index) => {
      const position = (index + 1) * 10 // gaps for inserts
      const input = lineElement.querySelector("input[name*='[position]']")
      if (input) input.value = position

      const tmp = lineElement.querySelector(".postemp")
      if (tmp) tmp.textContent = position
    })
  }

  addLine(event) {
    if (event) event.preventDefault()

    const fragment = this.templateTarget.content.cloneNode(true)
    const newLine = fragment.querySelector(".rule-line")

    // Replace placeholder with unique ID
    const uniqueId = Date.now()
    newLine.innerHTML = newLine.innerHTML.replace(/new_RECORD/g, `new_${uniqueId}`)

    // Always append to end
    this.linesTarget.appendChild(newLine)

    this.applyRemainderStyle()
    this.renumberLines()
  }

  removeLine(event) {
    event.preventDefault()
    const line = event.target.closest(".rule-line")
    if (line) {
      line.remove()
      this.applyRemainderStyle()
      this.renumberLines()
    }
  }

  applyRemainderStyle() {
    const lines = Array.from(this.linesTarget.querySelectorAll('.rule-line'))

    // Reset all lines to normal
    lines.forEach(line => {
      const removeButton = line.querySelector('button[name="remove"]')
      if (removeButton) removeButton.style.visibility = 'visible'

      const amountField = line.querySelector("input[name*='amount']")
      if (amountField) {
        amountField.placeholder = ""
        amountField.disabled = false
        amountField.readOnly = false
      }
    })

    // Style last line as remainder
    if (lines.length > 0) {
      const remainderLine = lines[lines.length - 1]

      const removeButton = remainderLine.querySelector('button[name="remove"]')
      if (removeButton) removeButton.style.visibility = 'hidden'

      const amountField = remainderLine.querySelector("input[name*='amount']")
      if (amountField) {
        amountField.placeholder = "Remainder"
        amountField.disabled = true
        amountField.readOnly = true
      }
    }
  }

  formatAmount(event) {
    const field = event.target
    const value = parseFloat(field.value)
    if (!isNaN(value)) {
      field.value = value.toFixed(2)
    }
  }
}
